module.exports = __webpack_public_path__ + "static/media/brussels sprout.ae2e8f5e.gif";